import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { LeadService } from '../../services/lead.service';
import { Broadcaster } from '../../services/broadcaster.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
})
export class SearchBarComponent implements OnInit {
  filteredOptions: Observable<string[]>;
  searchBar = new FormControl();
  leads: any[] = [];
  leadListReadySub: Subscription;

  constructor(
    private leadService: LeadService,
    private broadcaster: Broadcaster,
  ) {
    var objectValues = {
      page: 1,
      pageCount: 100000,
      term: null,
    };
    // get the leads, and store in leadList subject in Broadcaster Service
    this.leadListReadySub = this.broadcaster.leadList.subscribe(res => {
      for (let item of res) {
        if (item.name) {
          this.leads.push(item);
        }
      }
    });

    // register the onChange action on searchBar
    this.filteredOptions = this.searchBar.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (this.leadListReadySub) {
      this.leadListReadySub.unsubscribe();
    }
  }

  /**
   * check if option is related to the searched value
   * it checks if the searching value is in the option title or not
   * not necessarily in the beginning, it might be anywhere
   * @note if filtering array with no value then returns empty array
   * @param {string} value - to be checked with
   * @return {string[]} - filtered array that each item is matching the criteria
   * @private
   */
  private _filter(value: any): string[] {
    if (!value) return [];
    const filterValue = value.toLowerCase();
    return this.leads.filter(
      option => option.name.toLowerCase().indexOf(filterValue) != -1,
    );
  }
}
